export default "__VITE_ASSET__BGcBlRah__"